import {Dispatcher} from "../../../stem-core/src/base/Dispatcher";
import {NOOP_FUNCTION} from "../../../stem-core/src/base/Utils";
import {
    apiCalculateSubscriptionEditOffersPrice,
    apiCalculateSubscriptionOffersPrice,
    SubscriptionOfferStore
} from "../../../client/state/SubscriptionOfferStore";
import {iFrameMerchantService} from "../../services/IframeMerchantService";
import {addressController} from "./AddressController";
import {iFrameUserDataService} from "../../services/IFrameUserDataService";


export const SUBSCRIBE_PLAN_STATE = {
    subscribe: "subscribe",
    editSubscription: "editSubscription",
    giftSubscription: "giftSubscription",
};

class SubscribePlanController extends Dispatcher {
    discountCode = null;
    subscribePlanState = null;
    shareName = true;
    selectedOffer = null;
    applyPolicy = null;
    onSelectSuccess = NOOP_FUNCTION;
    onSelectCancel = NOOP_FUNCTION;
    onCancel = NOOP_FUNCTION;

    // Don't update these ones, they are used internally.
    discountCodeMap = new Map();
    instantChangeDiscountCodeMap = new Map();
    pendingRequests = 0;

    userHasEquivalentSubscriptionToOffer(subscriptionOffer) {
        const subscription = iFrameUserDataService.getActiveSubscription();
        if (!subscription) {
            return false;
        }
        if (!subscriptionOffer) {
            return true;
        }
        return subscription.billingPlan === subscriptionOffer.billingPlan && subscription.coverage === subscriptionOffer.coverage;
    }

    userHasEquivalentSubscriptionToSelected() {
        return subscribePlanController.selectedOffer == null || this.userHasEquivalentSubscriptionToOffer(subscribePlanController.selectedOffer);
    }

    updateEditPricesFromExistingSubscription() {
        if (this.userHasEquivalentSubscriptionToSelected()) {
            const subscription = iFrameUserDataService.getActiveSubscription();
            subscribePlanController.discountCodeMap.set(null, subscription.nextCyclePrice);
        }
    }

    async fetchSubscriptionEditPrices() {
        this.pendingRequests += 1;

        try {
            const {recurringOffers} = await apiCalculateSubscriptionEditOffersPrice({
                discountCode: this.discountCode,
                userAddressId: addressController.selectedAddress?.id,
                subscriptionId: iFrameUserDataService.getActiveSubscription().id,
            });
            this.instantChangeDiscountCodeMap.clear();
            this.discountCodeMap.clear();
            for (const info of recurringOffers) {
                const subscriptionOffer = info.recurringOfferId == null ? null : SubscriptionOfferStore.get(info.recurringOfferId);
                if (info.applyPolicy === "instantly") {
                    this.instantChangeDiscountCodeMap.set(subscriptionOffer, info);
                } else {
                    this.discountCodeMap.set(subscriptionOffer, info);
                }
            }
        } catch (error) {
            subscribePlanController.update({discountCode:  null});
        } finally {
            this.pendingRequests -= 1;
            if (!this.pendingRequests) {
                this.dispatch();
            }
        }
    }

    async checkDiscountCode() {
        this.pendingRequests += 1;
        this.discountCodeMap.clear();
        try {
            const {recurringOffers} = await apiCalculateSubscriptionOffersPrice({
                discountCode: this.discountCode,
                merchantId: iFrameMerchantService.merchantId,
                userAddressId: addressController.selectedAddress?.id
            });
            for (const info of recurringOffers) {
                this.discountCodeMap.set(SubscriptionOfferStore.get(info.recurringOfferId), info);
            }
        } catch (error) {
            this.update({discountCode:  null});
            // TODO: Handle API error.
        } finally {
            this.pendingRequests -= 1;
            if (!this.pendingRequests) {
                this.dispatch();
            }
        }
    }

    getDiscountInfo(offer) {
        return this.discountCodeMap.get(offer);
    }

    getDiscountInfoOnInstantChangePolicy(offer) {
        return this.instantChangeDiscountCodeMap.get(offer);
    }

    update(props) {
        Object.assign(this, props);
        this.dispatch();
    }

    clear() {
        subscribePlanController.update({
            selectedOffer: null,
            shareName: false,
            applyPolicy: null,
            discountCode: null,
            discountCodeMap: new Map(),
            instantChangeDiscountCodeMap: new Map(),
            pendingRequests: 0,
        });
    }
}

export const subscribePlanController = new SubscribePlanController();
